<template>
	<div class="activity">
		<div class="photo-list" v-show="active === 0" style="margin-top: 20px">
			<van-list v-model="photosLoading" :finished="photosFinished" finished-text="暂无更多作品" @load="photosLoad">
				<div class="item_panel" v-for="(item, i) in photoList" :key="i" @click="toPhotoDetail(item)">
					<div class="img-content-bottom-activityName">
						<span><img src="@/assets/images/icon_work_icon.png" /></span> {{ item.activityName }}
					</div>
					<div class="item">
						<!-- <div class="zzBack" v-if="item.worksType == 3">
							<p>
								该作品被驳回且未在指定时间内修改或被判无效参赛，报名失败！有疑问请联系平台/组委会。
							</p>
						</div> -->
						<div class="overallLeft identifier" v-if="!item.imgType">
							编号：{{ item.transactionId }}
						</div>
						<div class="item-content" v-if="!item.imgType">
							<div class="item-title">{{ item.name }}</div>
							<div class="item-tip">
								<span v-if="item.majorName">{{ item.majorName }}</span>
								<span v-if="item.groupName">{{ item.groupName }}</span>
							</div>
							<div class="overallLeft item-introduce">
								<span>作者:&nbsp;</span>
								<span>&nbsp;{{ item.babyName }}</span>
							</div>
							<div class="overallLeft item-introduce">
								<span>介绍:&nbsp;</span>
								<span>&nbsp;{{ item.synopsis }}</span>
							</div>
							<!-- <div class="overallLeft item-introduce2 AlignTop">
								<span class="AlignTop">比赛:&nbsp;</span>
								<span class="AlignTop">&nbsp;{{ item.activityName }}</span>
							</div> -->
							<!-- <div class="overallLeft item-introduce2 AlignTop" v-if="item.isStrong == 1">
								<span class="AlignTop">已提交原作</span>
							</div> -->
						</div>

						<div class="item-img-content" v-if="item.imgType">
							<div class="img-content-transactionId">
								编号：{{ item.transactionId }}
							</div>
							<div class="img-content">

								<img :src="item.imgType.url" />
								<div class="img-content-bottom">
									<div class="img-content-bottom-name">{{ item.name }}</div>
									<div class="overallbaseline">
										<div class="img-content-bottom-synopsis">
											{{ item.synopsis }}
										</div>
									</div>
								</div>
							</div>
							<div class="item-tip" style="margin-bottom: 0px">
								<a>{{ item.babyName }}</a>
								<span v-if="item.majorName">{{ item.majorName }}</span>
								<span v-if="item.groupName">{{ item.groupName }}</span>
							</div>
							<!-- <div class="overallLeft item-introduce3 AlignTop" v-if='item.isStrong == 1'>
								<span class="AlignTop">已提交原作</span>
							</div> -->
						</div>

						<div class="idTab-time" v-if="item.img && item.img.length > 0">
							<div class="idTab" v-for="(ks, index) in item.img" :key="index">
								<div class="overallBetween idTab-div">
									<div class="fileName">
										{{getfileTypeName(ks.fileType) }} | {{ ks.fileName }}
									</div>
									<a v-if="ks.fileType == 4" @click.stop="getcheck(ks)">查看></a>
									<a v-else-if="ks.fileType != 1" @click.stop="getcheck(ks)">查看></a>
								</div>
								<img v-setshow v-if="ks.fileType == 1" :src="ks.fileUrl" />
							</div>
						</div>
						<div class="like-share">
							<!-- 	<div class="lik-shr-lnk">
								<div>
									<img src="../../assets/images/active/active-like-ico.png" alt="" />
									<span>{{ item.likers }}</span>
								</div>
							</div> -->
							<div class=" view-cicc-btn" v-if="item.activityId != 71 " @click.stop="getTagsImg(item)">
								标签打印
							</div>
							<div v-if="
								(item.activityType == 0 || item.activityType == 1) &&
								item.achievementType == 2 &&
								item.prize <= 4 && item.prize != 0
							" class="view-cicc-btn" @click.stop="viewCcie(item)">
								查看证书
							</div>
							<div v-if="item.practiceCertImg" class="view-cicc-btn" @click.stop="getPracticalCertificate(item)">
								查看实践证书
							</div>


							<!--  2023/7/21 16:47  增加institutionId 机构报名的 用户端不能修改 activityTenantId saas 活动修改-->
							<template v-if="
								(TENANTID == 0 && !item.activityTenantId) ||
								(TENANTID != 0 && item.activityTenantId)
							">
								<div v-if="
									item.activityType == 0 &&
									!item.typeSub &&
									item.worksType != 2 &&
									(item.modifiableType == 0 || item.worksType == 1) &&
									item.institutionId == 0
								" class="view-cicc-btn" @click.stop="editInfo(item.id, item.activityId)">
									修改
								</div>
								<div v-if="
									item.activityType == 1 &&
									!item.typeSub &&
									item.worksType != 2 &&
									(item.modifiableType == 0 || item.worksType == 1) &&
									item.stageType == 0 &&
									item.institutionId == 0
								" class="view-cicc-btn" @click.stop="editInfo(item.id, item.activityId)">
									修改
								</div>
								<div v-if="item.commentNum == 0 && item.institutionId == 0" class="view-cicc-btn delet-btn"
									@click.stop="deleitem(item, i)">
									删除
								</div>
							</template>
						</div>
					</div>
				</div>
			</van-list>
		</div>
		<van-popup v-model="checkType" class="photo-tags" closeable position="bottom"
			:style="{ height: '100%', width: '100%' }" @close="beforeCloseHandler(checkData.fileType)">
			<div class="show-photo-tags">
				<img v-if="checkData.fileType == 1" :src="checkData.fileUrl" alt="" />
				<audio ref="audioPlayer" v-if="checkData.fileType == 2" width="100%" height="200" controls
					:src="checkData.fileUrl"></audio>
				<video ref="videoPlayer" v-if="checkData.fileType == 3" width="100%" height="200" controls
					:src="checkData.fileUrl"></video>
				<p style="text-align: center; margin-top: 20px" v-if="checkData.fileType == 5">
					<a style="font-size: 18px; color: #16d77a" :href="checkData.fileUrl">
						点击下载查看压缩文件
					</a>
				</p>
				<p style="text-align: center; margin-top: 20px" v-if="checkData.fileType == 4">
					<a style="font-size: 18px; color: #16d77a" :href="checkData.fileUrl">
						点击查看文档类作品
					</a>
				</p>
			</div>
		</van-popup>

		<img v-draggable class="botton_zuweihui" @click="getbotton_zuweihui"
			src="../../assets/images/home/botton_zuweihui.png" alt="" />

		<van-image-preview v-model="show" :images="images" @click="show = false">
			<template #cover>
				<div class="apply-ccie-btn" v-if="
					isCert == true &&
					(selItem.activityType == 0 || selItem.activityType == 1) &&
					selItem.achievementType == 2 &&
					selItem.prize <= 4 && selItem.prize != 0 &&
					(selItem.paperCertApplyConfig || {}).isOpenPaperCertApply == 1 &&
					selItem.institutionId == 0">
					<van-button size="large" @click.stop="handleApply(selItem)"
						color="linear-gradient(to right, #5DD682, #5AFF8E)">申请纸质证书</van-button>
				</div>
				<div class="pre-close" style="text-align: right">
					<van-icon @click.stop="show = false" name="close" :style="{
						margin: '10px',
						fontSize: '24px',
						color: '#fff',
						position: 'fixed',
						left: '10px',
						right: '10px'
					}" />
				</div>
			</template>
		</van-image-preview>
		<!-- <van-dialog
      v-model="showAddressInp"
      title="请填写寄送地址以便于邮寄证书"
      show-cancel-button
      @confirm="applyCcie"
      @cancel="(showAddressInp = false), (show = false)"
    >
      <textarea
        class="address-inp"
        placeholder="请输入邮寄地址"
        maxlength="64"
        v-model="addressStr"
      ></textarea>
      <span>{{ addressStr.length }} / 64</span>
    </van-dialog> -->
		<van-dialog v-model="showAddressInp" show-cancel-button @confirm="(showAddressInp = false), (show = false)"
			@cancel="(showAddressInp = false), (show = false)">
			<p style="padding: 0 20px">
				{{
					activityType == 1
						? contactInfo
						: "个人报名参赛的获奖者若需要申请纸质版获奖证书，请先阅读“学与玩杂志”公众号-比赛报名-获奖证书申领说明，再查看纸质版获奖证书联系方式，与所在赛区联系申请。"
				}}
				<!-- 如需申请纸质荣誉证书请联系比赛组委会本人自取，联系电话：010-66160277。如无法自取，可委托组委会代发快递，请关注比赛官方微信公众号“学与玩杂志”了解详情。 -->
			</p>
		</van-dialog>
		<div class="codeTags" v-if="tagsImgCode != ''" id="codeTags">
			<div class="codeTagsBox">
				<div class="codeBox">
					<img :src="tagsImgCode" />
				</div>
				<div class="codeTagsTxt">
					<div>赛事名称：{{ tagsImgTxt.activityName }}</div>
					<div>所属地区：{{ tagsImgTxt.zoneName }}</div>
					<div v-if="tagsImgTxt.institutionName">
						报名服务单位名称：{{ tagsImgTxt.institutionName }}
					</div>
					<div v-if="tagsImgTxt.mainBodyType == 2">团队成员：<span v-for="(item, index) in tagsImgTxt.list" :key='index'>{{
						item.name }}<i v-if="tagsImgTxt.list.length != (index + 1)">、</i> </span></div>
					<div v-if="tagsImgTxt.mainBodyType == 1">学生姓名：{{tagsImgTxt.babyName}}</div>
					<div v-if="tagsImgTxt.mainBodyType == 1">学生年龄：{{ JSON.parse(tagsImgTxt.babyInfo).age + "岁" }}</div>
					<div>组别：{{ tagsImgTxt.groupName }}</div>
					<div>作品名称：{{ tagsImgTxt.name }}</div>
					<div>作品类别：{{ tagsImgTxt.majorName }}</div>
					<div>作品编号：{{ tagsImgTxt.transactionId }}</div>
					<!-- <div>家长手机号：{{ tagsImgTxt.telNoHidden }}</div> -->
				</div>
			</div>
		</div>
		<van-popup v-model="showPhotoTags" class="photo-tags" closeable position="bottom"
			:style="{ height: '100%', width: '100%' }">
			<div class="show-photo-tags">
				<p>长按图片即可保存或分享</p>
				<p>打印尺寸:5cm*10cm</p>
				<img :src="tagsImg" alt="" />
				<p v-if="isTagsImg">绘画书法类原作收件地址：北京市西城区平安里西大街43号，比赛组委会（收），电话010-66160277</p>
			</div>
		</van-popup>
	</div>
</template>

<script>
import {
	localStorageGetItem
} from "@/utils/auth";
import {
	formatNumber,
	getfileTypeArr,
	getfileTypeName
} from "@/utils/tool";
import QRCode from "qrcode";
import html2canvas from "html2canvas";
import {
	getMyWorks,
	getUserNotification,
	getWorksCertificate,
	applyCert,
	h5DelWorks,
	getWorksDetails,
} from "@/utils/api/user";
export default {
	components: {
		// Sign
	},
	watch: {
		active: function (v) {
			this.photosFinished = false;
			this.noticeFinished = false;
			if (v) {
				this.noticePage = 0;
				this.noticeLoad();
			} else {
				this.photosPage = 0;
				this.photosLoad();
			}
		}
	},
	data() {
		return {
			isCert: false,
			selItem: {},
			TENANTID: 0,
			contactInfo: "",
			// 0作品；1通知
			active: 0,
			// 作品列表
			photoList: [],
			// loading
			photosLoading: false,
			// 是否全部加载
			photosFinished: false,
			// 作品页码
			photosPage: 0,
			// 每页条数
			photosPageSize: 10,
			// 查看证书
			show: false,
			//
			showAddressInp: false,
			// 证书
			images: [],
			// 地址
			addressStr: "",

			noticeList: [],
			noticeLoading: false,
			noticeFinished: false,
			noticePage: 0,
			noticePageSize: 10,
			showPhotoTags: false,
			isTagsImg: false,
			tagsImg: "",
			activityType: 0,

			checkType: false,
			checkData: {},
			tagsImgCode: "", //生成的二维码
			tagsImgTxt: "" //标签打印弹窗文字
		};
	},
	mounted() {
		this.TENANTID = localStorageGetItem("TENANT-ID") || "0";
		// this.getMyworksByPage(true);
		
	},
	methods: {
		getfileTypeName,
		// 纸质证书申领
		handleApply(item) {
			if (item.certOrderId) {
				this.$router.push({
					path: '/cert/detail',
					query: {
						id: item.certOrderId,
						time: item.paperCertApplyConfig.applyCertEndTime
					}
				})
			} else {

				console.log('item.paperCertApplyConfig.applyCertEndTime == ', item.paperCertApplyConfig.applyCertEndTime)

				var time = item.paperCertApplyConfig.applyCertEndTime || ''
				if (time.length > 0) {
					// 转换为 Date 对象
					const targetDate = new Date(time);
					const currentDate = new Date();

					// 比较时间
					if (currentDate >= targetDate) {
						this.$toast.fail("证书申领已截止");
						return
					}
				}
				this.$router.push({
					path: '/cert/apply',
					query: {
						workId: item.id,
						time: item.paperCertApplyConfig.applyCertEndTime
					}
				})
			}
		},

		// 去作品详情
		// type0 作品列表跳详情，1通知列表跳详情
		toPhotoDetail(item, type = 0) {
			console.log(item, type)
			// if (item.worksType == 3) {
			// 	return;
			// }
			if (type == 0 && item.typeSub) {
				this.$router.push({
					path: "/replenishinfo",
					query: {
						id: item.id,
						mode: 1
					}
				});
				this.$notify({
					type: "danger",
					message: "请先补充作品信息"
				});
				return;
			}
			// 在ios中由于vue与微信网页注册权限操作的兼容问题；不使用 push
			if (type)
				this.$root.mipLink("/player/photodetail", {
					id: item.worksId
				});
			else
				this.$root.mipLink("/player/photodetail", {
					id: item.id
				});
		},
		// 获取图片
		getTagsImg(data) {
			this.$toast.loading({
				message: '标签生成中...',
				forbidClick: true,
				loadingType: 'spinner',
				duration: 0
			});
			getWorksDetails(data.id).then((res) => {
				if (res.success) {
					this.isTagsImg = new Date(res.data.addTime).getTime() > new Date('2026-05-29 16:29:29').getTime();
					this.tagsImgTxt = res.data;
					this.$toast.loading({
						message: '标生成20%',
						forbidClick: true,
						loadingType: 'spinner',
						duration: 0
					});
					this.getCode(res.data);
				}
			})
		},
		getCode(msg) {
			// 合成二维码
			let id = String(msg.id);
			var urlhref = window.location.origin + '/scanPage?id=' + id
			let that = this;
			this.$nextTick(() => {
				QRCode.toDataURL(urlhref)
					.then((url) => {
						this.tagsImgCode = url;
						this.$toast.loading({
							message: '生成40%',
							forbidClick: true,
							loadingType: 'spinner',
							duration: 0
						});
						this.getCanvas();
					})
					.catch((err) => {
						that.$toast.fail("生成失败:" + err);
					});
			}, 500);
		},
		getCanvas() {
			//合成海报
			this.$toast.loading({
				message: '生成75%',
				forbidClick: true,
				loadingType: 'spinner',
				duration: 0
			});
			this.$nextTick(() => {
				var scrollTop = document.documentElement.scrollTop;
				window.scrollTo(0, 0);
				html2canvas(document.getElementById("codeTags"), {
					useCORS: true,
					allowTaint: true,
				}).then((canvas) => {
					window.scrollTo(0, scrollTop);
					//合成海报
					this.$toast.loading({
						message: '生成100%',
						forbidClick: true,
						loadingType: 'spinner',
						duration: 0
					});
					var url = canvas.toDataURL("image/png");
					this.tagsImg = url;
					this.tagsImgCode = "";
					this.showPhotoTags = true;
					this.$toast.clear()
				});
			}, 1000);
		},
		// 修改作品信息
		editInfo(id, activityId) {
			this.$router.push("/home/activityapply?id=" + id + '&activityId=' + activityId);
		},
		// 查看证书
		viewCcie(item) {
			this.selItem = item
			if (item.mainBodyType == 2) {
				this.$router.push("/home/certificate?id=" + item.id);
			} else {
				getWorksCertificate(item.id).then((res) => {
					if (res.success) {

						// =================
						// res.data.certUrl = "https://megagame-works.oss-cn-beijing.aliyuncs.com/90/2025/04/14/09/35/2025041409351045190676042734000.png"
						if (res.data.certUrl) {
							this.images = [res.data.certUrl];
							this.isCert = true
							this.show = true;
							this.contactInfo = item.contactInfo;
							this.chickId = item.id;
							this.activityType = item.activityType;
						} else {
							if (item.activityId == 31) {
								this.$toast.success("证书生成中请稍后查看");
							} else {
								this.$toast.success("当前活动没有电子证书");
							}
						}
					}
				});
			}
		},
		// 查看实践证书
		getPracticalCertificate(data) {
			this.images = [data.practiceCertImg];
			this.isCert = false
			this.show = true;
		},
		// 申请证书
		applyCcie() {
			if (!this.addressStr) {
				this.$toast.fail("地址信息不可为空");
				return;
			}
			const id = this.chickId;
			const str = this.addressStr;
			applyCert({
				receivingAddress: str,
				id
			}).then((res) => {
				if (res.success) {
					this.$toast.success("申请成功！");
					this.show = false;
					this.showAddressInp = false;
				}
			});
		},
		//删除作品
		deleitem(item, index) {
			this.$Dialog
				.confirm({
					title: "是否确认删除？",
					message: "作品未点评前可以删除作品，删除后该作品不可恢复，您可以选择重新上传",
					confirmButtonText: "确定",
					confirmButtonColor: "#3478f7",
					cancelButtonText: "取消",
					cancelButtonColor: "#fe1200"
				})
				.then(() => {
					let that = this;
					// 确定
					h5DelWorks(item.id).then((res) => {
						if (res.success) {
							that.photoList.splice(index, 1);
							that.getMyworksByPage();
							that.$root.$toast.success({
								message: "删除成功",
								duration: 1500
							});
						}
					});
				})
				.catch(() => {
					// 取消
				});
		},
		// 加载作品
		photosLoad() {
			this.photosPage++;
			this.getMyworksByPage(this.photosPage == 1);
		},
		// 加载通知
		noticeLoad() {
			this.noticePage++;
			this.getMynoticeByPage(this.noticePage == 1);
		},
		// 分页获取我的作品
		getMyworksByPage(init = false) {
			if (init) this.photoList = [];
			this.photosLoading = true;
			getMyWorks({
				pageNo: this.photosPage,
				pageSize: this.photosPageSize
			}).then((res) => {
				if (res.success) {
					const loadData = res.data.records.map((e) => {
						let imgsArr = getfileTypeArr(e.imgs);
						e.imgType = imgsArr.find((element) => element.fileType === 1);
						if (e.imgType) {
							imgsArr.splice(
								imgsArr.findIndex((res) => res.fileType === 1),
								1
							);
						}
						e.img = imgsArr;
						e.count = 1;
						e.likers = formatNumber(e.likeNum);
						return e;
					});
					let loadData2 = [];
					loadData.map((ks) => {
						let ktype = false;
						this.photoList.map((k) => {
							if (ks.id == k.id) {
								ktype = true;
							}
						});
						if (!ktype) {
							loadData2.push(ks);
						}
					});
					this.photoList.push(...loadData2);
				} else {
					this.photosLoading = false;
					this.photosFinished = true;
				}
				this.photosLoading = false;
				if (this.photosPage * this.photosPageSize > res.data.total) {
					this.photosFinished = true;
				}
			});
		},
		// 分页获取通知
		getMynoticeByPage(init = false) {
			if (init) this.noticeList = [];
			this.noticeLoading = true;
			getUserNotification({
				pageNo: this.noticePage,
				pageSize: this.noticePageSize
			}).then((res) => {
				if (res.success) {
					const loadData = res.data.records.map((e) => {
						return {
							id: e.id,
							img: e.imgs,
							title: e.noticeType == 0 ?
								"恭喜，您的作品已入围决赛！" : "您的作品可以查看评分和点评了！",
							time: e.addTime,
							type: e.noticeType,
							worksId: e.worksId
						};
					});
					this.noticeList.push(...loadData);
				} else {
					this.noticeLoading = false;
					this.noticeFinished = true;
				}
				this.noticeLoading = false;
				if (this.noticePage * this.noticePageSize > res.data.total) {
					this.noticeFinished = true;
				}
			});
		},
		/**
		 * @description: 关闭音视频
		 * @param {*} index
		 * @author: wangxiaoheng
		 */
		beforeCloseHandler() {
			if (this.$refs.audioPlayer) {
				this.$refs.audioPlayer.pause();
				this.$refs.audioPlayer.currentTime = 0;
			}
			if (this.$refs.videoPlayer) {
				this.$refs.videoPlayer.pause();
				this.$refs.videoPlayer.currentTime = 0;
			}
		},
		/**
		 * @description:  查看文件
		 * @param {*} ks
		 * @return {*}
		 * @author: wangxiaoheng
		 */
		getcheck(ks) {
			this.checkData = ks;
			this.checkType = true;
		},
		// 切割文字排列
		setTextToHtml(str) {
			let html = ``;
			str.split("").map((e) => {
				html += `<span>${e}</span>`;
			});
			return html;
		},
		shareByWechat() {
			// 微信分享
		},
		/**
		 * @description: 跳转标签介绍页
		 * @param {*}
		 * @return {*}
		 * @author: wangxiaoheng
		 */
		getbotton_zuweihui() {
			this.$router.push("/getLabel");
		}
	}
};
</script>
<style lang="scss" scoped>
.codeTags {
	//  position:fixed;
	//  left:800px;
	//  top:50px;
	width: 310px;
	background: linear-gradient(180deg, #31d076 0%, #81dba8 100%);
	border-radius: 8px 8px 8px 8px;
	//  z-index: 1000;
	margin: 0 30px;
	margin-top: 9999px;

	.codeTagsBox {
		padding: 15px;
	}

	.codeTagsTxt {
		background: #ffffff;
		border-radius: 8px 8px 8px 8px;
		padding: 15px;
		font-size: 14px;
		color: #222;
		line-height: 26px;
		text-align: left;
	}

	.codeBox {
		// padding: 10px;
		background-color: #fff;
		// width: 180px;
		// height: 180px;
		text-align: center;
		margin: 0 auto;
		border-radius: 8px 8px 8px 8px;
		margin-bottom: 15px;
		display: inline-block;

		img {
			width: 180px;
			height: 180px;
			border-radius: 8px 8px 8px 8px;
		}
	}
}

.activity {
	width: 100%;
	max-width: 10rem;
	padding: 0 15px;
	overflow: hidden;
	background: #f8f8f9;
	min-height: 100vh;

	.tabs-bar {
		position: fixed;
		top: 0;
		left: 0px;
		width: 375px;
		height: 52px;
		border-bottom: 1px solid #f2f2f2;
		background: #ffffff;
		box-shadow: 0px 3px 5px rgba(108, 221, 143, 0.26);
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #fff;
		z-index: 20;

		.bar-wrap {
			width: 100%;
			height: 30px;
			border-radius: 15px;
			display: flex;
			overflow: hidden;

			.tab {
				width: 50%;
				font-size: 16px;
				display: flex;
				align-items: center;
				justify-content: center;
				position: relative;
				color: #054b1b33;
				font-weight: bold;

				&.active {
					// background-color: #16d77a;
					color: #6cdd8f;

					&::after {
						content: "";
						height: 2px;
						width: 32px;
						position: absolute;
						bottom: 0;
						left: calc((100% - 32px) / 2);
						background-color: #6cdd8f;
					}
				}
			}
		}
	}

	.photo-list {
		margin-top: 70px;
		text-align: left;
		padding-bottom: 80px;

		.img-content-bottom-activityName {
			// display: inline-block;
			display: flex;
			align-items: center;

			padding: 10px 5px;
			// background: rgba(49, 208, 118, 0.1);
			border-radius: 8px 0px 8px 0px;
			// white-space:nowrap;
			// overflow:hidden;
			// text-overflow:ellipsis;
			// font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 12px;
			// color: #31D076;
			// line-height: 14px;

			font-weight: bold;
			font-size: 15px;
			color: #222222;
			line-height: 18px;

			span {
				margin-right: 5px;

				img {
					width: 6px;

				}
			}

		}

		.item_panel {
			padding-bottom: 30px;
		}

		.item {
			// margin-bottom: 40px;
			min-height: 200px;
			position: relative;
			background: #ffffff;
			border-radius: 8px;
			// height:2000px;
			overflow: hidden;

			&:last-child {
				margin-bottom: 0;
			}

			.zzBack {
				position: absolute;
				background-color: #000;
				height: 100%;
				left: 0;
				top: 0;
				border-radius: 8px;
				z-index: 99;
				color: #fff;
				background: #000;
				background: rgba(0, 0, 0, 0.8);
				display: flex;
				justify-content: center;
				align-items: center;

				p {
					font-size: 20px;
					padding: 0px 40px;
				}
			}

			.identifier {
				height: 36px;
				border-bottom: 1px solid #eeeeee;
				font-size: 12px;
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				color: #999999;
				padding-left: 15px;
			}

			.item-content {
				padding: 0px 15px;
				border-bottom: 1px solid #eeeeee;

				.item-title {
					margin-top: 12px;
					font-size: 16px;
					font-family: PingFang SC, PingFang SC;
					font-weight: bold;
					color: #222222;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.item-introduce {
					margin-bottom: 9px;

					span:first-child {
						display: inline-block;
						font-size: 12px;
						font-family: PingFang SC, PingFang SC;
						font-weight: 400;
						color: #666666;
					}

					span:last-child {
						max-width: 250px;
						display: inline-block;
						font-size: 12px;
						font-family: PingFang SC, PingFang SC;
						font-weight: 400;
						color: #222222;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}
				}

				.item-introduce2 {
					margin-bottom: 9px;

					span:first-child {
						display: inline-block;
						font-size: 12px;
						font-family: PingFang SC, PingFang SC;
						font-weight: 400;
						color: #666666;
					}

					span:last-child {
						max-width: 250px;
						display: inline-block;
						font-size: 12px;
						font-family: PingFang SC, PingFang SC;
						font-weight: 400;
						color: #222222;
					}
				}
			}


			.item-img-content {
				padding: 0px 15px;
				// padding-top: 15px;

				.img-content {
					position: relative;
					width: 315px;
					height: 200px;
					border-radius: 8px 8px 8px 8px;

					img {
						width: 315px;
						height: 200px;
						border-radius: 8px 8px 8px 8px;
					}
				}

				.img-content-transactionId {
					display: flex;
					align-items: center;
					justify-content: flex-start;
					// position: absolute;
					min-width: 170px;
					// height: 28px;
					gap: 20px;
					backdrop-filter: blur(2px);
					// background-color: rgba(0,191,255, 0.075);
					// color: #FFFFFF;
					background-color: rgba(255, 255, 255, 0.5);
					border-radius: 8px 0px 8px 0px;
					font-size: 12px;
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					color: #666;
					padding: 10px 0px;
				}

				.img-content-bottom {
					position: absolute;
					bottom: 0px;
					width: 315px;
					height: 61px;
					gap: 20px;
					// backdrop-filter: blur(2px);
					// background-color:rgba(0,191,255, 0.075);
					// background-color:rgba(32,94,218, 0.5);
					// background-color: linear-gradient(to bottom, #ffffff, #000000);
					// background-color: rgba(255, 255, 255, 0.5);

					background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 69%, rgba(0, 0, 0, 0.9) 100%);
					border-radius: 0px 0px 8px 8px;



					border-radius: 0px 0px 8px 8px;
					padding-left: 12px;
					padding-top: 8px;
				}

				.img-content-bottom-name {
					font-size: 18px;
					font-family: PingFang SC, PingFang SC;
					font-weight: 800;
					color: #FFFFFF;
					// color: #000;
				}

				.img-content-bottom-synopsis {
					width: 300px;
					max-width: 300px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					font-size: 12px;
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					color: #FFFFFF;
					// color: #000;
				}
			}

			.item-introduce3 {
				font-size: 15px;
				font-family: PingFang SC, PingFang SC;
				font-weight: bold;
				color: #222222;
			}

			.item-tip {
				margin-top: 9px;
				margin-bottom: 15px;

				a {
					font-size: 15px;
					font-family: PingFang SC, PingFang SC;
					font-weight: bold;
					color: #222222;
					line-height: 18px;
					margin-right: 10px;
				}

				span {
					display: inline-block;
					min-width: 46px;
					height: 20px;
					background: rgba(255, 114, 70, 0.1);
					border-radius: 25px 25px 25px 25px;
					padding: 0 10px;
					line-height: 20px;
					margin-right: 10px;
					font-size: 12px;
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					color: #ff7246;
				}
			}

			.idTab-time {
				padding: 18px 15px;
				border-bottom: 1px solid #eeeeee;

				.idTab:first-child {
					margin-bottom: 0px !important;
				}
			}

			.idTab {
				display: flex;
				align-items: center;
				width: 315px;
				min-height: 35px;
				background: #f8f8f9;
				border-radius: 8px 8px 8px 8px;
				padding: 2px 10px;
				margin-bottom: 10px;
				font-size: 12px;
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				color: #666666;

				.fileName {
					width: 250px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.idTab-div {
					width: 100%;
				}

				a {
					font-size: 12px;
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					color: #999999;
				}

				img {
					object-fit: contain;
					max-height: 210px;
					width: 100% !important;
					border-radius: 8px;
				}
			}

			.like-share {
				// display: flex;
				// justify-content: space-between;
				padding: 15px 15px;
				float: right;
				padding-bottom: 10px;

				.lik-shr-lnk {
					display: flex;

					&>* {
						margin-right: 8px;
					}

					&>div {
						display: flex;
						align-items: center;

						span {
							font-size: 14px;
							color: #999;
						}
					}

					img {
						height: 24px;
						width: 24px;
					}
				}

				.view-cicc-btn {
					// min-width: 79px;
					// height: 24px;
					border: 1px solid #31D076;
					// background: linear-gradient(180deg, #5dd682 0%, #5aff8e 100%);
					opacity: 1;
					border-radius: 18px;
					// text-align: center;
					// line-height: 24px;
					// color: #fff;
					// font-size: 12px;
					font-weight: 500;
					font-size: 13px;
					color: #31D076;
					display: inline-block;
					padding: 5px 13px;
					float: right;
					margin-left: 5px;
					margin-bottom: 5px;
				}

				.view-cicc-btn-color {
					background-color: #31D076;
					color: #fff;
				}

				.delet-btn {
					// width: 70px;
					// height: 24px;
					// background: gray;
					opacity: 1;
					// border-radius: 12px;
					// text-align: center;
					// line-height: 24px;
					color: #666666;
					// font-size: 12px;
					border-color: #C9C9C9;
				}
			}
		}
	}

	.notice-list {
		margin-top: 70px;
		text-align: left;
		padding-bottom: 80px;

		.item {
			min-height: 233px;
			position: relative;
			margin-bottom: 20px;
			display: flex;
			justify-content: flex-start;
			overflow: hidden;

			&:last-child {
				margin-bottom: 0;
			}

			.ntc-type {
				min-width: 40px;
				height: 40px;
				margin-right: 8px;

				&.cut {
					background-image: url("../../assets/images/active/ntc-cut-ico.png");
				}

				&.grade {
					background-image: url("../../assets/images/active/ntc-grd-ico.png");
				}

				background-repeat: no-repeat;
				background-position: 0 0;
				background-size: 100% 100%;
			}

			.infos {
				flex: 1;

				// width: calc(100% - 48px);
				.ntc-tit {
					display: flex;
					justify-content: space-between;
					width: 100%;
					height: 40px;
					align-items: center;

					.title {
						font-size: 12px;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						height: 100%;

						div {
							color: #000;
						}

						p {
							color: #999;
						}
					}

					&>p {
						font-size: 12px;
						font-weight: bold;
						color: #6cdd8f;
					}
				}

				.ntc-pto {
					margin-top: 12px;
					padding-bottom: 16px;
					border-bottom: 1px solid #999999;

					img {
						height: 155px;
						border-radius: 8px;
					}
				}
			}
		}
	}

	.apply-ccie-btn {
		position: fixed;
		height: 52px;
		bottom: 0px;
		width: 254px;

		.van-button {
			border-radius: 16px;
			width: 254px;
			height: 32px;
		}
	}
}

.botton_zuweihui {
	position: fixed;
	right: 3px;
	bottom: 190px;
	width: 109px;
	height: 62px;
	z-index: 1000;
}

.douyin_img {
	width: 100%;
	vertical-align: middle;
}
</style>

<style lang="scss">
.activity {
	.photo-list {
		.item {
			.sign {
				span {
					line-height: 16px;
				}
			}
		}
	}

	.van-image-preview {
		.van-image {
			padding: 0 20px;

			img {
				max-width: 335px;
			}
		}

		.van-image-preview__cover {
			.apply-ccie-btn {
				position: fixed;
				bottom: 20px;
				left: 60px;
			}
		}
	}

	.van-dialog__content {
		margin-top: 10px;
		position: relative;

		textarea {
			resize: none;
			width: 256px;
			height: 110px;
		}

		span {
			position: absolute;
			display: block;
			bottom: 5px;
			right: 35px;
		}
	}

	.van-popup.photo-tags {
		background-color: unset;

		.checkClass {
			width: 8.1067rem;
			border-radius: 0.4267rem;
			overflow: hidden;
			margin-top: 5vh;
			display: flex;
		}

		.show-photo-tags {
			height: 100%;
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			overflow: hidden;

			p {
				font-size: 14px;
				text-align: center;
				color: #f2f2f2;
			}

			img {
				width: 275px;
				border-radius: 16px;
				overflow: hidden;
				margin-top: 2vh;
				display: flex;
			}
		}
	}
}
</style>